var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"az-footer"},[_c('div',{staticClass:"container-fluid"},[_c('span',[_vm._v("© 2019 BluSalt")])])])
}]

export { render, staticRenderFns }